const Hamburger = ({
  className = ""
}: {
  className?: string;
}) => {
  return <svg width='37' height='35' viewBox='0 0 37 35' fill='currentColor' xmlns='http://www.w3.org/2000/svg' className={`${className}`} role='img' aria-labelledby='menuTitle' data-sentry-element="svg" data-sentry-component="Hamburger" data-sentry-source-file="Hamburger.tsx">
      <title id='menuTitle'>Hamburger Menu Icon</title>
      <path d='M36.1441 29.0076H0.0358887V34.25H36.1441V29.0076Z' data-sentry-element="path" data-sentry-source-file="Hamburger.tsx" />
      <path d='M36.1441 14.7437H0.0358887V19.9861H36.1441V14.7437Z' data-sentry-element="path" data-sentry-source-file="Hamburger.tsx" />
      <path d='M36.1441 0.468239H0.0358887V5.71063H36.1441V0.468239Z' data-sentry-element="path" data-sentry-source-file="Hamburger.tsx" />
    </svg>;
};
export default Hamburger;